import { createSlice } from '@reduxjs/toolkit';


export const utilityReducer = createSlice({
    name: "userDetailsReducer",
    initialState: {
        value: null
    },
    reducers: {
        updateUserDetail: (state, action) => {
            state.value = { ...state.value, ...action.payload};
        },
        clearUserDetails:(state, action)=>{
            state.value = action.payload;
        }
    }
})

export const { updateUserDetail,clearUserDetails } = utilityReducer.actions;

export default utilityReducer.reducer;